module.exports = __webpack_public_path__ + "img/拼一拼.457699bf.png";